export enum NumericFormatKinds {
  Invalid = 0,
  Normal = 1,
  Money = 2,
}
